import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { SIGNUP_FORM_TYPES } from 'dpl/constants/shared';


const { LOGIN } = SIGNUP_FORM_TYPES;

export default function UserLoginButton({
  pushParams,
  className,
  showSignupText,
  onClick
}) {
  return (
    <button
      className={ classnames('UserLoginButton', className) }
      onClick={ onClick || (() => pushParams({ direct_signup: LOGIN })) }
      data-test="header_login_button"
    >
      Log In { showSignupText && '/ Sign Up' }
    </button>
  );
}

UserLoginButton.propTypes = {
  pushParams: PropTypes.func.isRequired,
  className: PropTypes.string,
  showSignupText: PropTypes.bool,
  onClick: PropTypes.func
};

UserLoginButton.defaultProps = {
  className: null,
  showSignupText: true,
  onClick: null
};
